import { AccountView } from '../../account-window/account-view';
import { executeLinkAuthMethod } from '../../account-window/parts/execute-link-auth-method';
import { AuthMethod } from '../../account-window/parts/auth-method';
import { getGoogleSignIn } from "./get-google-sign-in";

export function initLinkGoogleAuthMethodEventListener() {
    return linkGoogleAuthMethod();
}

export async function linkGoogleAuthMethod(isBigReward?: boolean): Promise<void> {
    AccountView.hideSocialSwitchAccountError();
    AccountView.showAccountLoadingState();

    const googleSignIn = getGoogleSignIn();
    const credentials = await googleSignIn.authenticate();
    // @ts-ignore
    executeLinkAuthMethod(AuthMethod.GOOGLE, credentials, isBigReward);
}
